import { el } from 'redom';

class DefaultLabelView {

  constructor() {

    this.el = el('label');

  }

  update(option) {

    this.el.textContent = option.label;

  }

}

class SingleSelectOption {

  constructor(options) {

    this.index = -1;
    this.option = null;

    if (typeof options.LabelView === 'function') {
      this.view = new options.LabelView();
    } else {
      this.view = new DefaultLabelView();
    }

    this.onOptionSelect = options.onOptionSelect;

    this.el = el('li.single-select-option', {
      class: options.singleSelectOptionClass || ''
    }, [this.view]);

    this.registerEventHandlers();

  }

  registerEventHandlers() {

    this.el.addEventListener('click', this.handleOptionClick.bind(this));

  }

  handleOptionClick(event) {
    event.stopPropagation();
    event.preventDefault();
    this.onOptionSelect(this.index, this.option);
    return false;
  }

  update(option, index, options, singleSelect) {

    const selectedOptionClassName = 'active-select-option';
    const disabledClassName = 'disabled';
    const selected = singleSelect.isSelectedOption(index);

    this.option = option;
    this.index = index;

    if (selected === true) {
      this.el.classList.add(selectedOptionClassName);
    } else {
      this.el.classList.remove(selectedOptionClassName);
    }

    if (option.disabled === true) {
      this.el.classList.add(disabledClassName);
    } else {
      this.el.classList.remove(disabledClassName);
    }

    this.view.update(option, singleSelect.context, 'option');

  }

}

export default SingleSelectOption;